<template>
  <factory-access-dashboard-layout>
    <template>
      <div class="grid gap-3">
        <h5 style="font-size: 14px;"><i class="dot"></i>공장별 작업자 출입 현황</h5>

        <!-- 공장 리스트 별 지도 -->
        <div>
          <f-a-tabs class="mb-3" v-model="tab" :items="tabs" @input="onClickTab"/>

          <!-- 맵 속성 -->
          <f-a-buttons class="mb-3"
                       v-model="type"
                       :items="[/*{feather: 'RefreshCwIcon', key: 'refresh'}, '위성사진', 'Lay-out', */'도면']"
                       @click="onClickMapType"/>

          <div v-show="type === '도면'">
            <map-factory-access1 v-if="tab === '당진공장'" v-model="nav.zoneId" :markers="this.markers" @click="onClickAccessZone"/>
            <map-factory-access2 v-else-if="tab === '포항공장'" v-model="nav.zoneId" :markers="this.markers" @click="onClickAccessZone"/>
            <map-factory-access3 v-else-if="tab === '인천공장'" v-model="nav.zoneId" :markers="this.markers" @click="onClickAccessZone"/>
            <map-factory-access4 v-else-if="tab === '중앙기술연구소'" v-model="nav.zoneId" :markers="this.markers" @click="onClickAccessZone"/>
          </div>
        </div>
      </div>
    </template>
    <template #right>
      <factory-access-dashboard-right-info
        :title="`${nav.regionName} (${nav.zoneName || '전체'})`"
        :hover-key="hoverKey"
        :task-list="taskList"
        :select-zone-id="nav.zoneId"
        :select-board-id="nav.boardId"
        @mouseover="infoMouseover"
        @changeOptions="onChangeOptions"
        @reload="loadPostList(true)"
      />
    </template>
  </factory-access-dashboard-layout>
</template>
<script>
import FactoryAccessDashboardLayout from "@/views/project/dashboard/FactoryAccessDashboard/FactoryAccessDashboardLayout.vue";
import FactoryAccessDashboardRightInfo from "@/views/project/dashboard/FactoryAccessDashboard/FactoryAccessDashboardRightInfo.vue";
import FATabs from "@/views/project/dashboard/FactoryAccessDashboard/FATabs.vue";
import FAButtons from "@/views/project/dashboard/FactoryAccessDashboard/FAButtons.vue";
import HttpRequest from "@/util/HttpRequest";
import MapFactoryAccess1 from "@/views/project/dashboard/FactoryAccessDashboard/MapFactoryAccess1.vue";
import MapFactoryAccess2 from "@/views/project/dashboard/FactoryAccessDashboard/MapFactoryAccess2.vue";
import MapFactoryAccess3 from "@/views/project/dashboard/FactoryAccessDashboard/MapFactoryAccess3.vue";
import MapFactoryAccess4 from "@/views/project/dashboard/FactoryAccessDashboard/MapFactoryAccess4.vue";
import idb from "@/util/IndexDbUtil";

export default {
  name: "FactoryAccessDashboard",
  components: {
    MapFactoryAccess4,
    MapFactoryAccess3,
    MapFactoryAccess2,
    MapFactoryAccess1,
    FAButtons,
    FATabs,
    FactoryAccessDashboardRightInfo,
    FactoryAccessDashboardLayout},
  computed: {
    tabs () {
      return this.regions.map(region => {
        return region.name
      })
    },
    markers () {
      if (this.zones.length === 0) return [];

      console.log('🗺️ [DEBUG] markers computed 시작:', {
        zonesLength: this.zones.length,
        taskListLength: this.taskList.length,
        navIsCriticalWork: this.nav.isCriticalWork,
        navBoardId: this.nav.boardId,
        navStep: this.nav.step
      });

      const zones = this.zones.map(zone => {

        let center = {lat: 36.975819466907474, lng: 126.76977089885499};
        if (zone.paths) {
          const paths = JSON.parse(zone.paths).features[0].geometry.coordinates[0];
          center = this.calculatePolygonCenter(paths);
        }

        // 중점대상 현황일 때 다른 스타일 적용
        const isCriticalWork = this.nav.isCriticalWork;

        // this.taskList 에서 zone 정보 찾고 중복되지 않게 postIds 추가
        const postIds = [];

        console.log(`📍 [DEBUG] Zone ${zone.name} (ID: ${zone.id}) 처리:`, {
          taskListLength: this.taskList.length,
          isCriticalWork
        });

        this.taskList.forEach((data, index) => {
          if (data.zones[zone.id] && data.zones[zone.id].postIds) {
            // 중점대상 현황일 때는 중점대상 작업만 포함
            const 중점대상작업 = ['고소작업', '중장비 작업', '밀폐공간 작업', '굴착작업', '방사선 관련 작업'];
            const shouldInclude = !isCriticalWork || 중점대상작업.includes(data.task);

            console.log(`➕ [DEBUG] Zone ${zone.name}에 task ${data.task} 추가:`, {
              taskIndex: index,
              task: data.task,
              isCriticalWork,
              shouldInclude,
              postIdsToAdd: data.zones[zone.id].postIds,
              currentPostIds: [...postIds]
            });

            if (shouldInclude) {
              postIds.push(...data.zones[zone.id].postIds)
            }
          }
        });

        const markerCount = [...new Set(postIds)].length;

        console.log(`🎯 [DEBUG] Zone ${zone.name} 최종 계산:`, {
          rawPostIds: postIds,
          uniquePostIds: [...new Set(postIds)],
          markerCount,
          isCriticalWork,
          최종isCritical값: isCriticalWork
        });

        let markerStyle;
        if (isCriticalWork && markerCount > 0) {
          // 중점대상일 때는 삼각형 형태와 경고 색상 사용
          markerStyle = {
            fontWeight: 600,
            backgroundColor: "#FF6B6B",
            color: '#fff',
            width: '30px',
            height: '30px',
            borderRadius: '0',
            clipPath: 'polygon(50% 0%, 0% 100%, 100% 100%)', // 삼각형 모양
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: '2px solid #FF4757'
          };
        } else {
          // 기존 원형 스타일 유지
          markerStyle = {
            fontWeight: 500,
            backgroundColor: "#fff",
            color: 'red',
            width: '26px',
            height: '26px'
          };
        }

        return {
          id: zone.id,
          name: zone.name,
          style: markerStyle,
          lat: center.lat,
          lng: center.lng,
          edge: markerCount,
          isCritical: isCriticalWork, // 중점대상 여부 추가
        }
      })
      if (this.nav.zoneId > 0) {
        return zones.filter(zone => zone.id === this.nav.zoneId);
      }

      return zones;
    }
  },
  data () {
    return {
      steps: ['등록', '입문', '작업중', '작업완료', '출문'],
      tab: '',
      type: '도면',
      tooltip: null,
      regions: [], // 구역/존 목록 tabs 에 사용됨
      zones: [], // 선택한 구역의 존 목록
      hoverKey: '',
      taskList: [
        /**
         * {
         *    boardId: 976,
         *    key: "976_1공장_용광로_고소작업",
         *    task: "고소작업",
         *    count: 1,
         *    countStep: {
         *      0: 1,
         *      2: 1,
         *      3: 1,
         *    },
         *    postIds: [item.id],
         *    zoneIds: [zone.id],
         * }
         **/
      ],

      nav: {
        boardId: 976, // 게시판 ID
        step: -1, // -1: 전체, 0:등록, 2: 작업중, 3: 작업완료
        regionId: 0,
        regionName: '',
        zoneId: 0,
        zoneName: '',
        isCriticalWork: false, // 중점대상 현황 여부
      },
      currentLoadPostListOptions: undefined, //
    }
  },
  watch: {
    tab (name) {
      // 구역/존 선택시 상세 데이터 읽어오기
      const id = this.regions.find(region => region.name === name).id;
      this.nav.regionId = id;
      this.nav.regionName = name;
      this.loadRegionDetail(id)
    },
  },
  created() {
    this.loadRegionList();
  },
  methods: {

    loadRegionList () {
      const option = {
        params: {
          page: 1,
          perPage: 20,
          keyword: '', // 검색이 필요할 경우 사용,
        },
      };
      // keyword 를 사용하지 않을 경우 삭제
      if (option.params.keyword === '') {
        delete option.params.keyword;
      }

      const api = '/api/v1/region';
      HttpRequest.get(api, option)
        .then(response => {
          const data = response.data;
          this.regions = data.filter(region => region.name !== '본사');
          this.tab = this.regions[0].name;
          this.nav.regionId = this.regions[0].id;
          this.loadPostList();
        }).catch(err => {  })
    },
    loadRegionDetail (id) {
      const api = `/api/v1/region/${id}`;
      HttpRequest.get(api, {params: {id}})
        .then(response => {
          if (response && response.length > 0) {
            this.zones = response[0].zones;

            const ps = [];
            for (const zone of response[0].zones) {
              const paths = JSON.parse(zone.paths);
              if (paths) {
                ps.push(paths.features[0].geometry.coordinates[0])
              }
            }
          }
        }).catch(err => { console.log("err", err) })
    },

    calculatePolygonCenter (polygon) {
      let sumX = 0, sumY = 0;
      const pointCount = polygon.length;

      polygon.forEach(([x, y]) => {
        sumX += x;
        sumY += y;
      });

      return {
        lat: sumY / pointCount,
        lng: sumX / pointCount,
      }
    },


    // 네이버 지도 초기화
    initMap () {
      this.nav.zoneName = '';
      this.nav.zoneId = 0;

      this.clearSelectGeoJson();
    },

    onClickMapType (type) {
      if (type === 'refresh') {
        this.initMap();
      } else if (type === '위성사진') {
      } else if (type === 'Lay-out') {
      } else if (type === '도면') {

      }
    },

    infoMouseover (item) {

    },
    clearSelectGeoJson () {
      this.nav.zoneId = 0;
      this.loadPostList();
    },
    onClickTab (tab) {
      this.nav.regionId = this.regions.find(region => region.name === tab).id;
      this.initMap();
      this.loadPostList();
    },
    onChangeOptions (options) {
      console.log('📥 [DEBUG] onChangeOptions 받음:', {
        받은옵션: options,
        이전nav: { ...this.nav }
      });

      this.nav.boardId = options.boardId;
      this.nav.step = options.step;
      this.nav.isCriticalWork = options.isCriticalWork || false;

      console.log('🔄 [DEBUG] nav 업데이트됨:', { ...this.nav });

      this.loadPostList();
    },
    onClickAccessZone (zone) {
      this.nav.zoneId = parseInt(zone.id);
      this.nav.zoneName = zone.name;
      this.loadPostList();
    },

    statusNumber(body, workers) {
      const checkUserIds = (body.작업자내역 || []).map(user => (user.userId ? Number(`${user.userId}`) : 0));

      const json = {};
      for (let i = 0; i<workers.length; i++) {
        const worker = workers[i];
        if (checkUserIds.includes(worker.user_id)) {
          if (!json[worker.user_id]) {
            json[worker.user_id] = {
              입문시간: '',
              출문시간: '',
            }
          }

          // 종료시간, 연장시간을 체크해야 할까?
          if (new Date(worker.created_at).format('yyyy-MM-dd') >= new Date().format('yyyy-MM-dd')) {
            if (worker.data === '입문') {
              // 입문 시간중 가장 빠른 시간을 저장
              if (!json[worker.user_id].입문시간) {
                json[worker.user_id].입문시간 = worker.created_at;
              } else if (new Date(json[worker.user_id].입문시간) > new Date(worker.created_at)) {
                json[worker.user_id].입문시간 = worker.created_at;
              }
            }

            if (worker.data === '출문') {
              // 출문 시간중 가장 늦은 시간을 저장
              if (!json[worker.user_id].출문시간) {
                json[worker.user_id].출문시간 = worker.created_at;
              } else if (new Date(json[worker.user_id].출문시간) < new Date(worker.created_at)) {
                json[worker.user_id].출문시간 = worker.created_at;
              }
            }
          }
        }
      }

      let status = 0;
      const userIds = Object.keys(json);
      // 모든 사용자의 출문시간이 존재 하면 출문
      if (userIds.length > 0 && userIds.every(userId => json[userId].출문시간)) status = this.steps.indexOf('출문');

      // 사용자 중 한명이라도 입문시간이 존재하면 입문
      else if (userIds.some(userId => json[userId].입문시간)) status = this.steps.indexOf('입문');

      return Math.max(body.상태, status);
    },

    async loadPostList(forced = false) {
      const conditions = [];
      // 당일 검색
      // conditions.push({key: 'body.작업허가.작업종료일시', operator: '>=n', value: new Date().format("yyyy-MM-dd")})
      // conditions.push({key: 'body.작업허가.작업시작일시', operator: '<', value: new Date().addDays(1).format("yyyy-MM-dd")})
      conditions.push({key: 'body.작업허가.작업시작일시', operator: '>=', value: new Date().format("yyyy-MM-dd")})
      conditions.push({key: 'body.작업허가.작업시작일시', operator: '<', value: new Date().addDays(1).format("yyyy-MM-dd")})
      // 공장
      if (this.nav.regionId) {
        conditions.push({key: 'body.작업정보.작업구역.region.id', operator: '=', value: this.nav.regionId})
      }
      // 존
      if (this.nav.zoneId) {
        conditions.push({key: 'body.작업정보.작업구역.zone.id', operator: '=', value: this.nav.zoneId})
      }
      // 작업상태 (등록, 작업중, 작업완료 은 body.상태를 사용 입문,출문은 전체조회)
      if (this.nav.step === 0 || this.nav.step === 2 || this.nav.step === 3) {
        conditions.push({key: 'body.상태', operator: '=', value: this.nav.step})
      }

      const options = {
        page: 1,
        perPage: 1000,
        projectId: this.$route.params.proj_id,
        boardId: this.nav.boardId,
        conditions,
        withMeta: true,
        metaKeys: [
          'body.작업정보.작업구역.region.%',
          'body.작업정보.작업구역.zone.%',
          'body.상태%',
          'body.작업자내역[%',
          'body.운전자정보%',
          'body.inspectChecked[%',
          'body.작업정보.업체명.id',
          'body.작업정보.업체명.com_name',
          'body.작업정보.장비유형%',
          'body.장비유형%',
        ],
        // 사용하는 곳은 없으나, 더블클릭시 잦은 호출로 인한 중복 호출을 방지하기 위해 사용한 currentLoadPostListOptions 의 값에 변경을 주어
        // 누계, 입문, 출문 을 선택시 한번 더 호출하게 하기 위해 추가
        step: this.nav.step,
      };
      const jsonOptions = JSON.stringify(options);

      // 캐시 키 생성
      const cacheKey = `postList-${jsonOptions}`;
      const cacheExpiryKey = `${cacheKey}-expiry`;

      // 강제 새로고침이 아니고 캐시가 있는 경우 캐시된 데이터 사용
      if (!forced) {
        const cachedData = await idb.getItem(cacheKey);
        const cacheExpiry = await idb.getItem(cacheExpiryKey);
        const currentTime = new Date().getTime();

        // 캐시가 유효한지 확인 (1분 = 60000 밀리초)
        if (cachedData && cacheExpiry && currentTime < parseInt(cacheExpiry)) {
          this.taskList = JSON.parse(cachedData);
          return;
        }
      }

      if (forced || (options.boardId && this.currentLoadPostListOptions !== jsonOptions)) {
        this.currentLoadPostListOptions = jsonOptions;

        const list = await this._loadDefragmentation(options)
        if (this.nav.boardId === 981) {
          // 내부작업을 선택한 경우,
          // 981: 내부작업(직영), 986: 내부작업(사내수급) 모두 검색
          options.boardId = 986;
          const list2 = await this._loadDefragmentation(options)
          list.push(...list2);
        }

        this.taskList = this.convertList(list);

        // 결과 캐싱 (1분 동안 유효)
        const currentTime = new Date().getTime();
        await idb.setItem(cacheKey, JSON.stringify(this.taskList));
        await idb.setItem(cacheExpiryKey, (currentTime + 60000).toString());
      }
    },

    // 전체 목록을 다운로드 받기 위해 사용
    async _loadDefragmentation(options) {
      const response = await this.$store.dispatch("board/LOAD_POST_LIST", options);
      const list = [];
      list.push(...response.data);
      if (response.current_page !== response.last_page) {
        options.page = response.current_page + 1;
        list.push(... await this._loadDefragmentation(options));
      }
      return list
    },

    // 목록을 페이지에서 사용할 수 있도록 변환
    convertList (list) {
      if (!list || list.length === 0) {
        return [];
      }

      console.log('🔍 [DEBUG] convertList 시작:', {
        inputListLength: list.length,
        isCriticalWork: this.nav.isCriticalWork,
        boardId: this.nav.boardId,
        step: this.nav.step
      });

      const taskList = [];
      let totalProcessed = 0;
      let criticalFiltered = 0;
      let stepFiltered = 0;
      let statusFiltered = 0;

      for (const item of list) {
        totalProcessed++;
        // const body = JSON.parse(item.post_content).body;
        const body = item.postContents.body;
        const region = body.작업정보.작업구역.region;
        const zone = body.작업정보.작업구역.zone;
        const company = body.작업정보.업체명 || { id: 0, com_name: '기타' }
        const step = this.statusNumber(body, item.qr_reads)// 입출문상태: 1:입문, 4:출문 (loadPostList 함수에서 설정)

        console.log(`📝 [DEBUG] 처리중 아이템 ${totalProcessed}:`, {
          postId: item.id,
          region: region.name,
          zone: zone.name,
          company: company.com_name,
          step: step,
          stepName: this.steps[step],
          inspectChecked: body.inspectChecked
        });

        // 출입이 없는 등록 상태는 데이터에서 제외 (외부작업, 장비)
        if (this.nav.boardId !== 981 && step === 0) {
          statusFiltered++;
          console.log(`❌ [DEBUG] 등록 상태로 필터링됨 (step=${step}, boardId=${this.nav.boardId})`);
          continue;
        }

        // 상태가 선택되어 있을 경우 해당 상태만 조회
        if (this.nav.step !== -1 && this.nav.step !== step) {
          stepFiltered++;
          console.log(`❌ [DEBUG] 단계 필터링됨 (required=${this.nav.step}, actual=${step})`);
          continue;
        }

        // 중점대상 현황 필터링
        if (this.nav.isCriticalWork) {
          const 중점대상항목 = ['고소', '중장비', '밀폐', '방사선', '굴착'];
          const has중점대상 = body.inspectChecked && body.inspectChecked.some(item =>
            중점대상항목.some(keyword => item.includes(keyword))
          );
          console.log(`🎯 [DEBUG] 중점대상 체크:`, {
            inspectChecked: body.inspectChecked,
            중점대상항목,
            has중점대상
          });
          if (!has중점대상) {
            criticalFiltered++;
            console.log(`❌ [DEBUG] 중점대상 아니므로 필터링됨`);
            continue;
          }
        }

        // 장비
        if (body.장비유형) {
          const worker = body.운전자정보;
          for (let i = 0; i<body.장비유형.선택.length; i++) {
            const task = body.장비유형.선택[i];
            const key = `${item.board_id}_${region.name}_${zone.name}_${task}`;
            const find = taskList.find(data => data.task === task);
            if (find) {
              find.count += 1;

              // post 정보
              if (!find.posts[item.id]) {
                find.posts[item.id] = {
                  id: item.id,
                  companyId: company.id,
                  companyName: company.com_name,
                  worker,
                }
              }

              // zone 정보
              if (!find.zones[zone.id]) {
                find.zones[zone.id] = {
                  id: zone.id,
                  name: zone.name,
                  postIds: [item.id],
                }
              } else {
                // postIds 에 중복되지 않도록 post id 추가
                if (!find.zones[zone.id].postIds.includes(item.id)) {
                  find.zones[zone.id].postIds.push(item.id);
                }
              }

              // 상태별로 저장
              if (find.countStep[step]) {
                find.countStep[step] += 1;
              } else {
                find.countStep[step] = 1;
              }

            } else {
              taskList.push({
                boardId: item.board_id,
                key,
                task,
                count: 1,
                countStep: {
                  [step]: 1,
                },
                posts: {
                  [item.id]: {
                    id: item.id,
                    companyId: company.id,
                    companyName: company.com_name,
                    worker,
                  }
                },
                zones: {
                  [zone.id]: {
                    id: zone.id,
                    name: zone.name,
                    postIds: [item.id],
                  },
                },
              })
            }
          }
        }

        // 외부작업 / 내부작업
        else {
          const worker = body.작업자내역;
          console.log(`👷 [DEBUG] 외부/내부작업 처리:`, {
            postId: item.id,
            inspectChecked: body.inspectChecked,
            workerCount: worker ? worker.length : 0
          });

          for (let i = 0; i<body.inspectChecked.length; i++) {
            const task = body.inspectChecked[i];
            const key = `${item.board_id}_${region.name}_${zone.name}_${task}`;
            const find = taskList.find(data => data.task === task);

            console.log(`🔧 [DEBUG] 작업 추가: ${task}`, {
              postId: item.id,
              zone: zone.name,
              existingTask: !!find
            });

            if (find) {
              find.count += 1;

              // post 정보
              if (!find.posts[item.id]) {
                find.posts[item.id] = {
                  id: item.id,
                  companyId: company.id,
                  companyName: company.com_name,
                  worker,
                }
              }

              // zone 정보
              if (!find.zones[zone.id]) {
                find.zones[zone.id] = {
                  id: zone.id,
                  name: zone.name,
                  postIds: [item.id],
                }
              } else {
                // postIds 에 중복되지 않도록 post id 추가
                if (!find.zones[zone.id].postIds.includes(item.id)) {
                  find.zones[zone.id].postIds.push(item.id);
                }
              }

              // 상태별로 저장
              if (find.countStep[step]) {
                find.countStep[step] += 1;
              } else {
                find.countStep[step] = 1;
              }

            } else {
              taskList.push({
                boardId: item.board_id,
                key,
                task,
                count: 1,
                countStep: {
                  [step]: 1,
                },
                posts: {
                  [item.id]: {
                    id: item.id,
                    companyId: company.id,
                    companyName: company.com_name,
                    worker,
                  }
                },
                zones: {
                  [zone.id]: {
                    id: zone.id,
                    name: zone.name,
                    postIds: [item.id],
                  },
                },
              })
            }
          }
        }

      }

      console.log('📊 [DEBUG] convertList 결과:', {
        totalProcessed,
        statusFiltered,
        stepFiltered,
        criticalFiltered,
        finalTaskListLength: taskList.length,
        tasksByZone: taskList.reduce((acc, task) => {
          Object.keys(task.zones).forEach(zoneId => {
            const zoneName = task.zones[zoneId].name;
            if (!acc[zoneName]) acc[zoneName] = {};
            if (!acc[zoneName][task.task]) acc[zoneName][task.task] = 0;
            acc[zoneName][task.task] += task.zones[zoneId].postIds.length;
          });
          return acc;
        }, {})
      });

      return taskList
    }
  }
}
</script>

<style scoped>
.tools {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 100;
  background-color: #fff;
  border-radius: 6px;
}
</style>
